import React from 'react';

const Footer = () => {
    return (
        <React.Fragment>
            <footer >
                    <div className='d-flex justify-content-between align-items-center'>
                        <div>
                            {new Date().getFullYear()}{" "} © PAXITY
                        </div>
                        
                        <div>
                            Developed by Systalink
                        </div>
                    </div>
            </footer>
        </React.Fragment>
    );
};

export default Footer;